import { render } from "./MoveUserDialog.vue?vue&type=template&id=3dc32a85&scoped=true"
import script from "./MoveUserDialog.vue?vue&type=script&lang=js"
export * from "./MoveUserDialog.vue?vue&type=script&lang=js"

import "./MoveUserDialog.vue?vue&type=style&index=0&id=3dc32a85&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dc32a85"]])

export default __exports__